const INITIAL_STATE = {
  error: null,
  loading: null,
  data:[]
};

const EmailsMulti = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "EMAIL_MULTI_REQUEST":
      return { loading: true, error: false };
    case "EMAIL_MULTI_ERROR":
      return { loading: false, error: true };
    case "EMAIL_MULTI_SUCCESS":
      return { loading: false, error: false };
    default:
      return state;
  }
};

export default EmailsMulti;
